import React from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "@mui/material";

export default function Modal({ title, message, status, okBtnCallback, okBtnLabel, cancelBtnCallback }) {
  return (
    <Dialog
      open={status}
      onClose={cancelBtnCallback ?? okBtnCallback}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {cancelBtnCallback && (
          <Button onClick={cancelBtnCallback}>キャンセル</Button>
        )}
        <Button onClick={okBtnCallback} color={cancelBtnCallback ? "error" : "primary"}>
          {okBtnLabel ?? "OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

Modal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  status: PropTypes.bool,
  okBtnCallback: PropTypes.any,
  okBtnLabel: PropTypes.string,
  cancelBtnCallback: PropTypes.any,
};
